import React from "react";
import { Phone, EnvelopeSimple, WhatsappLogo } from "@phosphor-icons/react";
import { ROLE_LABEL } from "@/lib/auth";
import { fmtDate } from "@/lib/api";

function waPhone(raw) {
  if (!raw) return null;
  const digits = String(raw).replace(/[^\d]/g, "");
  return digits.length >= 8 ? digits : null;
}

const POOL_META = {
  accepted: { cls: "bg-emerald-50 text-emerald-700 border-emerald-300", label: "Accepted" },
  pending: { cls: "bg-blue-50 text-blue-700 border-blue-300", label: "Pending" },
  on_hold: { cls: "bg-slate-100 text-slate-500 border-slate-300", label: "On hold" },
  declined: { cls: "bg-rose-50 text-rose-700 border-rose-300", label: "Declined" },
};

export function JobAssignmentCard({ job, store, assignee, users, currentUserId }) {
  return (
    <div className="rmms-card p-5">
      <div className="overline mb-3">Assignment</div>
      {assignee ? (
        <div>
          <div className="text-sm">
            <span className="font-medium">{assignee.name}</span> · <span className="text-slate-500">{ROLE_LABEL[assignee.role] || assignee.role}</span>
          </div>
          {(assignee.phone || assignee.email) && (
            <div className="mt-2 flex flex-wrap gap-1.5">
              {assignee.phone && (
                <a href={`tel:${assignee.phone}`} data-testid="job-assignee-call"
                  className="inline-flex items-center gap-1.5 text-[11px] px-2 py-1 border border-slate-200 rounded-sm hover:bg-slate-50 hover:border-[#002FA7] hover:text-[#002FA7] transition-colors font-mono-data">
                  <Phone size={11} weight="fill" /> {assignee.phone}
                </a>
              )}
              {waPhone(assignee.phone) && (
                <a
                  href={`https://wa.me/${waPhone(assignee.phone)}?text=${encodeURIComponent(`Hi ${assignee.name?.split(" ")[0] || ""}, regarding ${job.job_number} — ${job.title} at ${store?.name || "the store"}. ${window.location.href}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="job-assignee-whatsapp"
                  className="inline-flex items-center gap-1.5 text-[11px] px-2 py-1 border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-sm hover:bg-emerald-100 hover:border-emerald-400 transition-colors"
                >
                  <WhatsappLogo size={11} weight="fill" /> WhatsApp
                </a>
              )}
              {assignee.email && (
                <a href={`mailto:${assignee.email}?subject=${encodeURIComponent(`${job.job_number} — ${job.title}`)}&body=${encodeURIComponent(`Job link: ${window.location.href}\n\n`)}`} data-testid="job-assignee-email"
                  className="inline-flex items-center gap-1.5 text-[11px] px-2 py-1 border border-slate-200 rounded-sm hover:bg-slate-50 hover:border-[#002FA7] hover:text-[#002FA7] transition-colors">
                  <EnvelopeSimple size={11} weight="fill" /> Email
                </a>
              )}
            </div>
          )}
        </div>
      ) : (
        <span className="text-slate-400 text-sm">{(job.assignee_pool && job.assignee_pool.length) ? "Offered, awaiting acceptance" : "Not assigned"}</span>
      )}
      {(job.assignee_pool || []).length > 0 && (
        <div className="mt-3 pt-3 border-t border-slate-100" data-testid="job-assignee-pool">
          <div className="overline mb-1.5 text-[10px]">Assignee Pool ({job.assignee_pool.length})</div>
          <ul className="space-y-1">
            {job.assignee_pool.map((p) => {
              const u = users.find((x) => x.id === p.user_id);
              const meta = POOL_META[p.status] || { cls: "bg-slate-100 text-slate-500 border-slate-300", label: p.status };
              return (
                <li key={p.user_id} data-testid={`pool-${p.user_id}`} className="flex items-center justify-between text-[12px]">
                  <span className={p.user_id === currentUserId ? "font-semibold" : ""}>
                    {u?.name || p.user_id}{p.user_id === currentUserId && " (you)"}
                  </span>
                  <span className={`text-[10px] font-heading uppercase tracking-wider font-semibold border rounded-sm px-1.5 py-0.5 ${meta.cls}`}>{meta.label}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="text-xs text-slate-500 mt-3">Store: {store?.name || "—"}</div>
      <div className="text-xs text-slate-500">Created: {fmtDate(job.created_at)}</div>
    </div>
  );
}
